import SubscriptionService from "../../../services/Subscription.service";
import {alertResponseError, alertResponseSuccess} from "../../../helpers/general";
import {PLAN_ID} from "../../../const/common";
import OrganizationService from "../../../services/OrganizationService";
import {email, maxLength, required} from "vuelidate/lib/validators";
import {ERRORS_CODE} from "../../../const/error_code";

let stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
const style = {
    base: {
        color: "#32325d",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
            color: "#aab7c4"
        }
    },
    invalid: {
        color: "#fa755a",
        iconColor: "#fa755a"
    }
};

export default {
    data() {
        return {
            isRegister: false,
            formSubmitted: false,
            lang: '',
            stripe: null,
            elements: null,
            card: null,
            mail: '',
            stripeCardError: "",
            planInfo: {
                planId: "",
                planName: "",
                numberAiModel: 0,
                title_second: '',
                title_three: '',
                price: 0,
                ai_model: ''
            }
        };
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        this.setDataDefault();
    },
    mounted() {
        this.configureStripe();
        this.getOrganization();
        const elementSetLang = document.querySelector('#control-set-lang');
        let self = this;
        elementSetLang.addEventListener('change', function() {
            self.setDataDefault();
            self.configureStripe();
        });
    },
    methods: {
        getOrganization() {
            OrganizationService.getDetailOrganization().then((response) => {
                if (response.data.success) {
                    this.mail = response.data.data.invoice_mail;
                }
            }).catch((error) => {
                return alertResponseError(error);
            })
        },
        setDataDefault() {
            if (this.$route.params.plan_type === PLAN_ID.light_plan) {
                this.planInfo.planName = this.$t("subscription.light_plan.name");
                this.planInfo.planId = this.$route.params.plan_type;
                this.planInfo.numberAiModel = this.$t("subscription.light_plan.number_ai_model");
                this.planInfo.title_second = this.$t("subscription.light_plan.title_second");
                this.planInfo.title_three = this.$t("subscription.light_plan.title_three", {volume: this.$route.query.volume});
                this.planInfo.price = this.$t("subscription.light_plan.price");
                this.planInfo.ai_model = this.$t("subscription.light_plan.ai_model");
            } else if (this.$route.params.plan_type === PLAN_ID.stand_plan) {
                this.planInfo.planName = this.$t("subscription.standard_plan.name");
                this.planInfo.planId = this.$route.params.plan_type;
                this.planInfo.numberAiModel = this.$t("subscription.standard_plan.number_ai_model");
                this.planInfo.title_second = this.$t("subscription.standard_plan.title_second");
                this.planInfo.title_three = this.$t("subscription.standard_plan.title_three", {volume: this.$route.query.volume});
                this.planInfo.price = this.$t("subscription.standard_plan.price");
                this.planInfo.ai_model = this.$t("subscription.standard_plan.ai_model");
            }
        },
        configureStripe() {
            let locale =  localStorage.getItem('language');
            let elements = stripe.elements({
                locale: locale ? locale : 'ja'
            });
            let card = elements.create("card", style);
            this.stripe = stripe;
            this.elements = elements;
            card.mount(this.$refs.stripe_card);
            this.card = card;
        },
        handlePurchase() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            } else {
                return this.purchase();
            }
        },
        purchase() {
            this.isRegister = true;
            stripe.createPaymentMethod("card", this.card, {
                billing_details: {
                    email: this.mail
                }
            }).then((result) => {
                if (result.error) {
                    this.formSubmitted = false;
                    this.isRegister = false;
                    this.stripeCardError = result.error.message;
                    return;
                } else {
                    return this.handleCreateSubscription(result.paymentMethod.id);
                }
            }).catch((error) => {
                this.formSubmitted = false;
                return alertResponseError(error.response.statusText);
            });
        },
        handleCreateSubscription(paymentMethodId) {
            return SubscriptionService.createSubscription({invoice_mail: this.mail, payment_method: paymentMethodId, plan_id: this.planInfo.planId}).then((response) => {
                if (response.data.success) {
                    this.isRegister = false;
                    alertResponseSuccess(this.$t("common_message.create_success")).then((value) => {
                        if (value) {
                            this.$router.push({name: 'subscription'});
                        }
                    });
                }
            }).catch((error) => {
                this.isRegister = false;
                if (error.response.data.errorCode === ERRORS_CODE.VALIDATION_ERROR) {
                    alertResponseError(this.$t('message_error.UNIQUE_INVOICE_MAIL'));
                } else {
                    return alertResponseError(error.response.statusText);
                }
            });
        },
    },
    validations() {
        return {
            mail: { required, email, maxLength: maxLength(254) },
        }
    },
    computed: {
        emailErrorMsg() {
            if (!this.$v.mail.required) {
                return this.$t('common_errors.required', { field: this.$t('common.mail_address') });
            }
            if (!this.$v.mail.email) {
                return this.$t('message_error.EMAIL_INVALID');
            }
            if (!this.$v.mail.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.email.$params.maxLength.max });
            }
            return null;
        },
    }
};
